import {
  Clock,
  MapPin,
  ClipboardCheck,
  Heart,
  MessagesSquare,
  CalendarDays,
} from "lucide-react";

export const schoolBenefits = [
  {
    icon: Clock,
    title: "Minimal classroom disruption",
    body: "Appointments are structured to keep students in class as much as possible.",
  },
  {
    icon: MapPin,
    title: "Convenient on-site care",
    body: "No parent travel, no missed appointments. Care happens where the children already are.",
  },
  {
    icon: ClipboardCheck,
    title: "Simple administration support",
    body: "We supply consent forms, scheduling templates and clear communication for staff.",
  },
  {
    icon: Heart,
    title: "Improved oral health awareness",
    body: "Age-appropriate education leaves students with lifelong habits, not just cleaner teeth.",
  },
  {
    icon: MessagesSquare,
    title: "Clear communication with parents",
    body: "Every family receives a plain-English report after their child's visit.",
  },
  {
    icon: CalendarDays,
    title: "Flexible scheduling",
    body: "We work around your calendar — exam blocks, camps and school events included.",
  },
];
